import * as React from 'react'

export function Pulse() {
    return (
        <div className="AppCore__ui__Pulse__container">
            <div className="AppCore__ui__Pulse" role="progressbar" />
        </div>
    )
}
